import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://chatrasangbad.org";
const SITE_NAME = "Chatra Sangbad";

const routeSEO = {

  "/": {
    title: "ছাত্র সংবাদ | Chatra Sangbad",
    description:
      "ছাত্র সংবাদ — সংবাদ, প্রবন্ধ, সম্পাদকীয়, ক্যাম্পাস রিপোর্ট, প্রকাশনা, ছবি, ভিডিও ও ছাত্র সংলাপ।",
  },

  "/editorial": {
    title: "Editorial | Chatra Sangbad",
    description:
      "Read editorials, analysis and perspectives published by Chatra Sangbad.",
  },

  "/articles": {
    title: "Articles | Chatra Sangbad",
    description:
      "Explore international, national, state, sports, science, literature, environment and other articles from Chatra Sangbad.",
  },

  "/articles/international": {
    title: "International Articles | Chatra Sangbad",
    description:
      "Read international affairs, global developments and analysis from Chatra Sangbad.",
  },

  "/articles/national": {
    title: "National Articles | Chatra Sangbad",
    description:
      "Read national issues, developments and analysis from Chatra Sangbad.",
  },

  "/articles/state": {
    title: "State Articles | Chatra Sangbad",
    description:
      "Read state-level articles, issues and analysis from Chatra Sangbad.",
  },

  "/articles/sports": {
    title: "Sports | Chatra Sangbad",
    description:
      "Read sports news, commentary and analysis from Chatra Sangbad.",
  },

  "/articles/science": {
    title: "Science & Technology | Chatra Sangbad",
    description:
      "Explore science, technology, innovation and research-related articles from Chatra Sangbad.",
  },

  "/articles/ink-and-echo": {
    title: "Ink & Echo | Chatra Sangbad",
    description:
      "Explore stories, poems and literary articles in Ink & Echo from Chatra Sangbad.",
  },

  "/articles/ink-and-echo/stories": {
    title: "Stories | Ink & Echo | Chatra Sangbad",
    description:
      "Read stories published under Ink & Echo by Chatra Sangbad.",
  },

  "/articles/ink-and-echo/poems": {
    title: "Poems | Ink & Echo | Chatra Sangbad",
    description:
      "Read poems and poetry published under Ink & Echo by Chatra Sangbad.",
  },

  "/articles/ink-and-echo/articles": {
    title: "Literary Articles | Ink & Echo | Chatra Sangbad",
    description:
      "Read literary articles, reflections and cultural writing under Ink & Echo by Chatra Sangbad.",
  },

  "/articles/environment": {
    title: "Environment | Chatra Sangbad",
    description:
      "Read environmental news, issues and analysis from Chatra Sangbad.",
  },

  "/articles/her-space": {
    title: "Her Space | Chatra Sangbad",
    description:
      "Read women's voices, experiences, rights, ideas and achievements in Her Space.",
  },

  "/articles/tribal-voices": {
    title: "Tribal Voices | Chatra Sangbad",
    description:
      "Read about indigenous communities, culture, identity and issues in Tribal Voices.",
  },

  "/news": {
    title: "News | Chatra Sangbad",
    description:
      "Read state, national, organisational news and press releases from Chatra Sangbad.",
  },

  "/news/state": {
    title: "State News | Chatra Sangbad",
    description:
      "Read state news, movements and important updates from Chatra Sangbad.",
  },

  "/news/national": {
    title: "National News | Chatra Sangbad",
    description:
      "Read national news and important developments from Chatra Sangbad.",
  },

  "/news/organisational": {
    title: "Organisational News | Chatra Sangbad",
    description:
      "Read organisational activities, meetings, campaigns and updates from Chatra Sangbad.",
  },

  "/news/press-release": {
    title: "Press Releases | Chatra Sangbad",
    description:
      "Read official statements and press releases published by Chatra Sangbad.",
  },

  "/campus-report": {
    title: "Campus Report | Chatra Sangbad",
    description:
      "Read campus reports, student issues, activities and developments from Chatra Sangbad.",
  },

  "/photos-videos": {
    title: "Media | Chatra Sangbad",
    description:
      "Explore photos, videos and Chatra Sanglap from Chatra Sangbad.",
  },

  "/photos-videos/photos": {
    title: "Photos | Chatra Sangbad",
    description:
      "Browse photographs and visual coverage published by Chatra Sangbad.",
  },

  "/photos-videos/videos": {
    title: "Videos | Chatra Sangbad",
    description:
      "Watch videos and media coverage published by Chatra Sangbad.",
  },

  "/photos-videos/chatra-sanglap": {
    title: "Chatra Sanglap | Chatra Sangbad",
    description:
      "Watch conversations, interviews and discussions through Chatra Sanglap.",
  },

  "/publications": {
    title: "Publications | Chatra Sangbad",
    description:
      "Browse books, newspapers and magazines published or archived by Chatra Sangbad.",
  },

  "/publications/books": {
    title: "Books | Chatra Sangbad",
    description:
      "Browse books and available digital editions from Chatra Sangbad.",
  },

  "/publications/newspapers": {
    title: "Newspapers | Chatra Sangbad",
    description:
      "Browse newspaper editions and archives from Chatra Sangbad.",
  },

  "/publications/magazines": {
    title: "Magazines | Chatra Sangbad",
    description:
      "Browse magazine editions and special publications from Chatra Sangbad.",
  },

  "/about-us": {
    title: "About Us | Chatra Sangbad",
    description:
      "Learn about Chatra Sangbad, its editorial work, history and team.",
  },

};


function PageSEO() {

  const location = useLocation();

  useEffect(() => {

    const pathname =
      location.pathname !== "/" &&
      location.pathname.endsWith("/")
        ? location.pathname.slice(0, -1)
        : location.pathname;


    /*
      Individual post SEO is already handled
      by PostDetails + Netlify Edge Function.
    */
    if (pathname.startsWith("/post/")) {
      return;
    }


    const config = routeSEO[pathname];

    if (!config) {
      return;
    }


    const canonicalUrl =
      pathname === "/"
        ? `${SITE_URL}/`
        : `${SITE_URL}${pathname}`;


    const originalTitle =
      document.title;


    const changedMeta = [];


    const setMeta = (
      selector,
      attribute,
      key,
      value
    ) => {

      let element =
        document.head.querySelector(
          selector
        );


      if (element) {

        changedMeta.push({
          element,
          existed: true,
          content:
            element.getAttribute(
              "content"
            )
        });

      } else {

        element =
          document.createElement(
            "meta"
          );

        element.setAttribute(
          attribute,
          key
        );

        document.head.appendChild(
          element
        );

        changedMeta.push({
          element,
          existed: false,
          content: null
        });

      }


      element.setAttribute(
        "content",
        value
      );

    };


    document.title =
      config.title;


    setMeta(
      'meta[name="description"]',
      "name",
      "description",
      config.description
    );


    setMeta(
      'meta[property="og:type"]',
      "property",
      "og:type",
      "website"
    );


    setMeta(
      'meta[property="og:site_name"]',
      "property",
      "og:site_name",
      SITE_NAME
    );


    setMeta(
      'meta[property="og:title"]',
      "property",
      "og:title",
      config.title
    );


    setMeta(
      'meta[property="og:description"]',
      "property",
      "og:description",
      config.description
    );


    setMeta(
      'meta[property="og:url"]',
      "property",
      "og:url",
      canonicalUrl
    );


    setMeta(
      'meta[name="twitter:card"]',
      "name",
      "twitter:card",
      "summary"
    );


    setMeta(
      'meta[name="twitter:title"]',
      "name",
      "twitter:title",
      config.title
    );


    setMeta(
      'meta[name="twitter:description"]',
      "name",
      "twitter:description",
      config.description
    );


    let canonical =
      document.head.querySelector(
        'link[rel="canonical"]'
      );


    const canonicalExisted =
      Boolean(canonical);


    const originalCanonical =
      canonical?.getAttribute(
        "href"
      );


    if (!canonical) {

      canonical =
        document.createElement(
          "link"
        );

      canonical.setAttribute(
        "rel",
        "canonical"
      );

      document.head.appendChild(
        canonical
      );

    }


    canonical.setAttribute(
      "href",
      canonicalUrl
    );


    return () => {

      document.title =
        originalTitle;


      changedMeta.forEach(
        ({
          element,
          existed,
          content
        }) => {

          if (!existed) {

            element.remove();

          } else {

            element.setAttribute(
              "content",
              content || ""
            );

          }

        }
      );


      if (canonicalExisted) {

        canonical.setAttribute(
          "href",
          originalCanonical || ""
        );

      } else {

        canonical.remove();

      }

    };

  }, [location.pathname]);


  return null;

}


export default PageSEO;